import { useNavigation } from "@react-navigation/native";
import { SettingsDataManagementNavigationProp, routeDataManagementSettings } from "../../Routes";
import SettingsContainer from "../../components/Layout/SettingsContainer";
import LabelContainer from "../../components/SettingsComponent/labelContainer";
import LegalButton from "../../components/LegalButton";
import iconProceed from "../../assets/TopNavBarIcon/icon_nav_proceed.png";
import { Linking, View } from "react-native";
import { AsyncStorageKeys, Pages } from "../../Types";
import YourPrivacyChoice from "../../assets/Icons/YourPrivacyChoices.png";
import { globalAny } from "../../utils/Utils";
import { useEffect } from "react";
import useLegalContentStore from "../../store/useLegalContent.store";
import useToggleStore from "../../store/useToggle.store";

const SettingsLegal = () => {
	const isDefaultTerritory = localStorage.getItem(AsyncStorageKeys.RegionOverride) === "US";
	const { fetchLegals, fetchAcceptOtherData } = useLegalContentStore((state: any) => ({
		fetchLegals: state.fetchLegals,
		fetchAcceptOtherData: state.fetchAcceptOtherData,
	}));
	const { isToggleHideDataMgmt } = useToggleStore((state: any) => ({
		isToggleHideDataMgmt: state.isToggleHideDataMgmt,
	}));

	/**
	 * Determines whether data management actions should be disabled
	 * based on the `isToggleHideDataMgmt` flag.
	 *
	 * @returns {boolean} - True if data management is hidden/disabled, false otherwise.
	 */
	const isDisabled = () => {
		if (isToggleHideDataMgmt) {
			return true;
		}
		return false;
	};

	/**
	 * Navigation hook for settings data management screens.
	 */
	const navigationSettingsDataManagement = useNavigation<SettingsDataManagementNavigationProp>();

	/**
	 * Navigates to the legal information screen within data management settings.
	 */
	const onLegal = () => {
		navigationSettingsDataManagement.navigate(routeDataManagementSettings, { location: Pages.legal });
	};

	/**
	 * Navigates to the privacy policy screen within data management settings.
	 */
	const onPrivacy = () => {
		navigationSettingsDataManagement.navigate(routeDataManagementSettings, { location: Pages.privacy });
	};

	/**
	 * Navigates to the data acceptance screen unless data management is hidden.
	 */
	const onData = () => {
		if (isToggleHideDataMgmt) return;
		navigationSettingsDataManagement.navigate(routeDataManagementSettings, { location: Pages.acceptData });
	};

	/**
	 * Fetches legal documents and data acceptance information on component mount.
	 */
	useEffect(() => {
		(async () => {
			await fetchLegals(AsyncStorageKeys.legals);
			await fetchAcceptOtherData(AsyncStorageKeys.acceptOtherData);
		})();
	}, []);

	return (
		<View style={{ paddingTop: 30, marginBottom: 30 }}>
			<SettingsContainer>
				{isDefaultTerritory ? (
					<LabelContainer
						header={globalAny.language.your_privacy_choices}
						body={globalAny.language.privacy_spiel}
						onPressBody={() => Linking.openURL("https://www.sonypicturescore.com/")}
						onClickableBody={false}
						imageSource={YourPrivacyChoice}
					/>
				) : (
					<></>
				)}
				<LegalButton onPress={onLegal} title={globalAny.language.legal_terms} rightIcon={iconProceed} />
				{!isToggleHideDataMgmt && (
					<LegalButton onPress={onData} title={globalAny.language.data_management} rightIcon={iconProceed} disabled={isDisabled()} />
				)}
				<LegalButton onPress={onPrivacy} title={globalAny.language.privacy_policy} rightIcon={iconProceed} />
			</SettingsContainer>
		</View>
	);
};

export default SettingsLegal;
